// ═════════════════════════════════════════════════════════════════════════════
// Insurance plan API client
//
//   POST {API_ROOT}insurance/insuranceplan/request
//     { ipd_id, payer_code, policy_number, description? }
//
// Unlike coverage-eligibility / pre-auth / claim this is a plain synchronous
// POST — there is no correlation id to poll for.
// ═════════════════════════════════════════════════════════════════════════════

import axios from "axios";
import { nhcxUrl, nhcxHeaders, normalizeNhcxError } from "./nhcx-client";

export async function submitInsurancePlan(body) {
  const res = await axios.post(nhcxUrl("/insuranceplan/request"), body, {
    headers: nhcxHeaders(),
  });
  return res.data;
}

export function normalizeInsurancePlanError(err) {
  return normalizeNhcxError(err, {
    404: "Admission not found on the insurance service.",
  });
}
